module.exports = __webpack_public_path__ + "media/products_of_the_shelf_scanned.dce42276.webm";